"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImmerBasedPatchTypes = exports.ENTIRE_COLLECTION_REPLACED = void 0;
exports.opForPatch = opForPatch;
exports.ENTIRE_COLLECTION_REPLACED = "__ENTIRE_COLLECTION_REPLACED__";
var ImmerBasedPatchTypes;
(function (ImmerBasedPatchTypes) {
    ImmerBasedPatchTypes["patchSequence"] = "patchSequence";
})(ImmerBasedPatchTypes || (exports.ImmerBasedPatchTypes = ImmerBasedPatchTypes = {}));
/**
 * Extract the op from a given immer patch.
 */
function opForPatch(patch) {
    return patch.op;
}
//# sourceMappingURL=patch.js.map